import { Input } from "@/shared/components/ui/input";

export function SearchInput({
  value,
  onChange,
  placeholder = "Suche...",
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
}) {
  return (
    <Input
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.currentTarget.value)}
    />
  );
}
